import React, { forwardRef } from 'react';
import type { ButtonProps } from '@mui/material';

import { StyledButton } from './Button.styles';

/**
 * Primitive Button component with consistent styling
 * Applies design patterns while maintaining full MUI Button API compatibility
 * Forwards refs to support Tooltip and other wrapper components
 */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'contained', color = 'primary', size = 'large', children, ...props }, ref) => {
    return (
      <StyledButton ref={ref} variant={variant} color={color} size={size} {...props}>
        {children}
      </StyledButton>
    );
  },
);

Button.displayName = 'Button';
